import { Component, OnInit } from "@angular/core";
import { DataService } from "../../data.service";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ModePaiement } from "../../model/modePaiement";
import {Message,MessageService} from 'primeng/api';
import { Router } from '@angular/router';
import { AuthenticationService } from "src/app/authentication.service";

// import { ConfirmDialogModule } from "primeng/confirmdialog";
// import { ConfirmationService } from "primeng/api";
@Component({
  selector: "app-types",
  templateUrl: "mode-paiement.component.html",
  styleUrls: ["mode-paiement.component.scss"],
  providers: [MessageService],
})
export class ModePaiementComponent implements OnInit {
  myUrl: string = `${environment.urlApi}`;
  imageUrl: string = this.myUrl + "/api/api/uploads/default.png";
  fileToUpload: File = null;
  ModePaiement: ModePaiement = {};
  ModePaiements: ModePaiement[];
  selectedType: ModePaiement;
  displayDialog: boolean;
  selectedOption: string;
  selectedFile = null;
  constructor(
    private data: DataService, private http: HttpClient,
    private messageService: MessageService,
    public AuthenticationService: AuthenticationService,
    private router: Router) {}
  ngOnInit() {
    this.modePaiement();
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    };
    reader.readAsDataURL(this.fileToUpload);
  }

  onUpload() {
    // alert(this.ModePaiement.modePaiement);
    this.ModePaiement.chemin = this.myUrl + "/api/api/";
    this.data
      .posteFile(
        this.ModePaiement.id,
        this.ModePaiement.modePaiement,
        this.ModePaiement.chemin,
        this.fileToUpload
      )
      .subscribe((data: { message: string; url: string }) => {
        // alert(data);
        // console.log(data);
        alert(data.message);
        this.modePaiement();
        this.displayDialog = false;
      });
  }
  modePaiement() {
    this.ModePaiement.action = "Select";
    this.ModePaiement.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .modePaiement(this.ModePaiement)
      .toPromise()
      .then((x: ModePaiement[]) => (this.ModePaiements = x));
  }
  save() {
    if (this.ModePaiement.classement == null) {
      alert("classement est vide - رقم التسلسل فارغ");
    } else if (this.ModePaiement.modePaiement == null) {
      alert("famille est vide - النوع فارغ");
    } else {
      if (this.ModePaiement.id) {
        this.ModePaiement.action = "Update";
        this.ModePaiement.DBase = this.AuthenticationService.currentUserValue.DBase;
        this.data
          .modePaiement(this.ModePaiement)
          .toPromise()
          .then((res: { message: string }) => {
            if (res.message == "Opération de modification réuissie") {
              this.messageService.add({severity:'success', summary: 'Sauvegarde', detail: res.message});
              this.displayDialog = false;
              this.modePaiement();
            } else {
              console.log(res);
              alert(res.message);
              alert("Nonnnn");
            }
          });
      } else {
        this.ModePaiement.action = "Insert";
        this.ModePaiement.DBase = this.AuthenticationService.currentUserValue.DBase;
        this.data
          .modePaiement(this.ModePaiement)
          .toPromise()
          .then((res: { message: string }) => {
            if (res.message == "Opération de modification réuissie") {
              this.messageService.add({severity:'success', summary: 'Sauvegarde', detail: res.message});
              this.displayDialog = false;
              this.modePaiement();
            } else {
              alert(res.message);
              this.displayDialog = false;
            }
          });
      }
    }
  }
  delete() {
    if (confirm("êtes vous sure?")) {
      this.ModePaiement.dateNow = new Date().toISOString().split("T")[0]; 
      this.ModePaiement.action = "Delete";
      this.ModePaiement.DBase = this.AuthenticationService.currentUserValue.DBase;
      this.data
        .modePaiement(this.ModePaiement)
        .toPromise()
        .then((res: { message: string }) => {
          if ((res.message = "Opération de supression réuissie")) {
            alert(res.message);
            this.displayDialog = false;
            this.modePaiement();
          } else {
            alert("Nonnnn");
          }
        });
    }
  }
  actionLink(lien) {
    this.router.navigate(["/"+lien]);
  }
  close() {
    this.displayDialog = false;
    this.ModePaiement = {};
  }
  newDonnee: boolean;
  showDialogToAdd() {
    this.newDonnee = true;
    this.imageUrl = this.myUrl + "/API/api/uploads/default.png";
    this.ModePaiement = {};
    this.displayDialog = true;
  }
  onRowSelect(event) {
    console.log(event);
    this.newDonnee = false;
    var leet = this.myUrl + "/API/api/uploads/images/" + event.data.images;
    this.imageUrl = leet;
    // alert(leet);
    this.ModePaiement = this.cloneDonnee(event.data);
    this.displayDialog = true;
  }
  cloneDonnee(c: ModePaiement): ModePaiement {
    let ModePaiement = {};
    for (let prop in c) {
      ModePaiement[prop] = c[prop];
    }
    return ModePaiement;
  }
}
